import React from 'react';
import Types from 'prop-types';
import FooterIconLink from './FooterIconLink';
import FooterTextLink from '../../../common/FooterTextLink';
var FooterLink = function FooterLink(_ref) {
  var icons = _ref.icons,
    link = _ref.link,
    translationKey = _ref.translationKey;
  return /*#__PURE__*/React.createElement("li", {
    className: icons ? 'footer-icon-links d-flex justify-content-center justify-content-start--md' : ''
  }, icons ? icons.map(function (_ref2) {
    var iconLink = _ref2.link,
      external = _ref2.external,
      Icon = _ref2.Icon,
      ariaLabel = _ref2.ariaLabel;
    return /*#__PURE__*/React.createElement(FooterIconLink, {
      link: iconLink,
      external: external,
      Icon: Icon,
      key: iconLink,
      ariaLabel: ariaLabel
    });
  }) : /*#__PURE__*/React.createElement(FooterTextLink, {
    translationKey: translationKey,
    link: link
  }));
};
FooterLink.defaultProps = {
  icons: null,
  translationKey: null,
  link: null
};
export default FooterLink;